import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { LocaleProvider } from "./lib/i18n";
import "./brand.css";
import "./dashboard.css";
import { applyTitle } from "./lib/page-title";

// Initialise the Telegram WebApp chrome when available. No-op in browser preview.
interface TelegramWebAppLike {
  ready?: () => void;
  expand?: () => void;
}
const w = window as unknown as { Telegram?: { WebApp?: TelegramWebAppLike } };
try {
  w.Telegram?.WebApp?.ready?.();
  w.Telegram?.WebApp?.expand?.();
} catch {
  // older clients omit some APIs
}

// The initial GA page view is sent from here (not index.html) so it carries
// the real screen title instead of the static fallback.
applyTitle(window.location.pathname);
(window as unknown as { gtag?: (...args: unknown[]) => void }).gtag?.("config", "G-1PV99TH7BG");

const root = document.getElementById("app");
if (!root) throw new Error("missing #app root element");

createRoot(root).render(
  <StrictMode>
    <LocaleProvider>
      <RouterProvider router={router} />
    </LocaleProvider>
  </StrictMode>,
);
